export default "__VITE_ASSET__CtGtZ3JX__"